
import SampleService from "@/services/SampleService";
import Galleria from "primevue/galleria";
import { defineComponent } from "vue";
export default defineComponent({
  components: {
    Galleria,
  },
  props: {
    id: {
      type: Number,
      default: 0,
    },
    compare: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    productID: 0,
    product: {
      image: "" as string,
      gallery: [] as Array<any>,
    },
    productImage: null,
    showGallery: false,
    tableData: [
      {
        user: "Experienced user",
        date_1: "0,00 €",
        date_2: "0,00 €",
        date_3: "0,00 €",
      },
      {
        user: "Inexperienced user",
        date_1: "0,00 €",
        date_2: "0,00 €",
        date_3: "0,00 €",
      },
    ],
  }),
  mounted() {
    this.getProduct();
  },
  methods: {
    getProduct() {
      SampleService.getProducts().then((data) => {
        this.product = data[1];
        if (this.product.image) {
          this.productImage = require("@/assets/images/" + this.product.image);
        }
        if (this.product?.gallery) {
          this.product.gallery.map((item: any) => {
            item.itemImageSrc = require("@/assets/images/" + item.itemImageSrc);
            item.thumbnailImageSrc = require("@/assets/images/" +
              item.thumbnailImageSrc);
          });
        }
      });
    },
  },
});
